import { apiSlice } from "../../app/api/apiSlice";

export const updateMilestoneFreeRolesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		updateMilestoneFreeRoles: builder.mutation({
			query: ({ loan_guid, loan_officer, loan_processor, account_executive }) => ({
				url: "/api/v1/loan/update_milestone_free_roles/",
				method: "POST",
				body: {
					loan_guid,
					loan_officer,
					loan_processor,
					account_executive,
				},
			}),
		}),
	}),
});

export const { useUpdateMilestoneFreeRolesMutation } =
	updateMilestoneFreeRolesApiSlice;